import { SearchAvailableGeoAreasForAppVariantRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'configs';
import { useSharedAppApi } from 'services';

export const useSearchGeoArea = (
  request: SearchAvailableGeoAreasForAppVariantRequest
) => {
  const { searchGeoAreas } = useSharedAppApi();

  return useQuery({
    queryKey: [queryKeys.geoAreas, { request }],
    queryFn: () => searchGeoAreas(request),
    enabled: request.search.length > 2,
    staleTime: Infinity
  });
};
